import { $el, getStrTypeAttr, removeAttrs, setHtml } from '../../dom-utils';
import { moreThanOneNode } from '../../mixins';
import PREFIX from '../prefix';
var Jumbotron = /** @class */ (function () {
    function Jumbotron() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-jumbotron', { all: true });
        this._create(this.COMPONENTS);
    }
    Jumbotron.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            if (moreThanOneNode(node))
                return;
            var placeholderNode = node.firstElementChild;
            var _a = _this._attrs(node), title = _a.title, subTitle = _a.subTitle;
            _this._setMainTemplate(node, title, subTitle);
            _this._setExtraContent(node, placeholderNode);
            removeAttrs(node, ['title', 'sub-title']);
        });
    };
    Jumbotron.prototype._setMainTemplate = function (node, title, subTitle) {
        var template = "\n         <div class=\"" + PREFIX.jumbotron + "-container\">\n             <h1 class=\"" + PREFIX.jumbotron + "-title\">" + title + "</h1>\n             <div class=\"" + PREFIX.jumbotron + "-subtitle\">" + subTitle + "</div>\n         </div>";
        setHtml(node, template);
    };
    Jumbotron.prototype._setExtraContent = function (node, placeholderNode) {
        if (!placeholderNode)
            return;
        var JumbotronContainer = node.querySelector("." + PREFIX.jumbotron + "-container");
        JumbotronContainer === null || JumbotronContainer === void 0 ? void 0 : JumbotronContainer.appendChild(placeholderNode);
    };
    Jumbotron.prototype._attrs = function (node) {
        return {
            title: getStrTypeAttr(node, 'title', ''),
            subTitle: getStrTypeAttr(node, 'sub-title', '')
        };
    };
    return Jumbotron;
}());
export default Jumbotron;
